import { FC } from 'react'
import { Menu as InternalMenu, MenuProps } from './menu'
import { MenuItem, MenuItemProps } from './menu-item'
import { MenuItemGroup } from './menu-item-group'
import { SubMenu, SubMenuProps } from './submenu'

interface MenuType extends FC<MenuProps> {
  Item: typeof MenuItem
  ItemGroup: typeof MenuItemGroup
  SubMenu: typeof SubMenu
}

const Menu = InternalMenu as MenuType
Menu.Item = MenuItem
Menu.ItemGroup = MenuItemGroup
Menu.SubMenu = SubMenu

export { Menu }
export type { MenuProps, MenuItemProps, SubMenuProps }
